<template>
  <div class="form-item-panel">
    <template v-if="data.id">
      <div class=" record " :class="isPad?'pad-font':''" style="margin-top: 5px" v-show="data.inputTip" v-html="data.inputTip">        
      </div>
      <!-- 量表结论展示-->
      <div class="record-result" :class="isPad?'pad-font':''" style="margin-top: 5px" v-if="resultFormItemList.length>0 && data.status!=='1'&&data.status!=='2'">
        <template v-for="(formItem,index) in resultFormItemList">
          <div :key="index">
            <div>
              {{formItem.name}}：{{formItem.value||''}}
            </div>
            <div>
              {{formItem.name}}结论：{{formItem.result||'-'}}
            </div>
          </div>
        </template>
      </div>
      <a-form-model :model="form" ref="ruleForm" layout="vertical" style="padding-left: 20px;padding-right: 20px;" :rules="rules" >
        <template v-for="(item,index) in data.formItemList">
          <base-form-view-item :baseData="data" :readOnly="readOnly" @valueChange="itemValueChange" :questionList="questionList" :show-tip-btn="showTipBtn" :form-item="item" :form.sync="form" v-if="item.scale!=='1' && item.conceal!=='1'" :key="index"></base-form-view-item>
        </template>
        <div style="text-align: right">
          <slot name="btn"></slot>
        </div>
      </a-form-model>
    </template>
    <a-modal
      title="结论"
      :width="800"
      :visible="resultVisible"
      switchFullscreen
      @ok="resultVisible = false"
      @cancel="resultVisible = false"
      cancelText="关闭">
    <div class="record-result" style="margin-top: 5px" v-if="resultFormItemList.length>0 && data.status!=='1'&&data.status!=='2'">
      <template v-for="(formItem,index) in resultFormItemList">
        <div :key="index">
          <div>
            {{formItem.name}}：{{formItem.value||''}}
          </div>
          <div>
            {{formItem.name}}结论：{{formItem.result||'-'}}
          </div>
        </div>
      </template>
    </div>
    </a-modal>
  </div>
</template>

<script>
  import BaseFormViewItem from './BaseFormViewItem.vue'
  import {elementTypeData ,CACHE_PROJECT_ID} from '@/constants/project'
  import baseRules from '@/constants/baseRules'
  import {CACHE_IS_PAD } from '@/constants/project'
  import { getAction,postAction } from '@/api/manage'
  import Vue from 'vue'

  export default {
    name: 'BaseFormView',
    components: { BaseFormViewItem },
    props:{
      questionList:{
        type:Array,
        default(){
          return []
        }
      },
      readOnly:{
        type:Boolean,
        default:false,
      },
      baseData:{
        type:Object,
        default:()=>{
          return {}
        }
      },
      showTipBtn:{
        type:Boolean,
        default:false
      },
      isLoad:{
        type:Boolean,
        default:true
      },
      isView:{//是否预览进入
        type:Boolean,
        default:false
      },
    },
    computed:{

    },
    watch:{
      baseData(){
        if(this.isLoad){
          this.loadData()
        }
      }
    },
    mounted(){
      if(this.isLoad){
        this.loadData()
      }
    },
    data(){
      return {
        elementTypeData:elementTypeData,
        data:{
          formItemList:[]
        },
        resultFormItemList:[],
        form:{},

        rules : {},
        isPad:Vue.ls.get(CACHE_IS_PAD),
        resultVisible:false,
      }
    },
    methods:{
      resultFormItemListHandle(){
        if(!this.data || !this.data.formItemList){
          return []
        }
        if(this.isView){
          return this.data.formItemList.filter(formItem=>formItem.scale==='1')
        }
        return this.data.formItemList.filter(formItem=>formItem.conceal!=='1' && formItem.scale==='1')
      },
      itemValueChange(formItem,value){
        if(this.$refs.ruleForm){
          this.$emit('formChange',formItem)
        }

      },
      validate(){
        let validResult = false
        let errResult = {  }
        this.$refs.ruleForm.validate((valid,errorData)  => {
          validResult = valid
          if(!valid){
            errResult = errorData
          }
        })
        return [validResult,errResult]
      },
      loadData(resultView){
        this.data = JSON.parse(JSON.stringify(this.baseData))
        this.resultFormItemList = this.resultFormItemListHandle()
        const form = {}
        this.initFrom(this.data.formItemList,form)
        this.form = form
        // 还要创建rules
        this.rules = {}
        const rules = {name:[{"required":true,"message":"请输入内容","trigger":"blur"}],}
        // if(this.data.formItemList){
        //   this.data.formItemList.forEach(item=>{
        //     if('1' === item.required){
        //       rules[item.id] = [baseRules.required]
        //     }
        //   })
        // }
        this.requiredRule(rules,this.data.formItemList)
        this.rules = rules
        this.$nextTick(()=>{
          if(resultView && this.resultFormItemList.length>0){
            this.resultVisible = true
          }
        })
      },
      requiredRule(rules,itemList){
        if(itemList){
          itemList.forEach(item=>{
            if('1' === item.required){
              rules[item.id] = [baseRules.required]
            }
            if( item.checkReg){
              rules[item.id] = rules[item.id] || []
              rules[item.id].push({pattern: new RegExp(item.checkReg) , message: '请输入正确格式内容', trigger: 'change'})
            }
            if(item.children){
              this.requiredRule(rules,item.children)
            }
          })
        }
      },
      initFrom(formItemList,form){
        if(formItemList && formItemList.length>0){
          formItemList.forEach(item=>{
            let value = item.value
            if(value){
              if( item.type ===elementTypeData.number.value ){
                if(item.reDecimal==='1'){
                  value = parseFloat(value)
                }else{
                  value = parseInt(value)
                }
              }
              else if(item.type ===elementTypeData.check.value ){
                value = value.split(',')
              }
              else if(elementTypeData.slider.value === item.type ){
                value = parseInt(value)
              }
              form[item.id] = value
            }else if(item.type ===elementTypeData.check.value){
              form[item.id] = []
            }
            else if(item.type ===elementTypeData.slider.value){
              form[item.id] = item.minLength || 0
            }
            else{
              form[item.id] = ''
            }
            this.initFrom(item.children,form)
          })
        }
      },
      getFormData(){
        return this.form
      },
      setFormData(key,value){
        this.$set(this.form,key,value)
      },
      //预览时量表计算结果
      setFormItemResult(result){
        if(!this.data || !this.data.formItemList){
          return
        }
        if(!result || result.length==0){
          return
        }
        this.data.formItemList.forEach(item=>{
          result.forEach(re=>{
            if(item.id===re.id){
              this.$set(item,"value",re.value)
              this.$set(item,"result",re.result)
            }
          })          
        })
        this.resultFormItemList = this.data.formItemList.filter(formItem=>formItem.scale==='1')
        this.resultVisible = true
      },
    }
  }
</script>

<style scoped lang="less">
  .record{
    border:1px solid rgba(57,188,206,0.5);
    border-radius: 5px;
    padding: 10px;
    background-color: #E7F3E2;
    color:#59C62C;
  }
  .record-result{
    border:1px solid rgba(57,188,206,0.5);
    border-radius: 5px;
    padding: 10px;
    color:#4291C6;
  }
  .pad-font{
    font-size: 13px;
  }
</style>